import CounterLink from 'components/Nav/subcomponents/CounterLink'
import SecurityLink from 'components/Nav/subcomponents/SecurityLink'

export default {
  recommendations: {
    component: CounterLink,
    native: true,
    props: { as: 'div', counter: 'summary' },
  },
  'recommendations/audits': {
    component: CounterLink,
    props: { counter: 'audit' },
  },
  'recommendations/benchmarks': {
    component: CounterLink,
    props: { counter: 'benchmark' },
  },
  'recommendations/campaigns': {
    component: CounterLink,
    props: { counter: 'recommendation' },
  },
  'user/security': {
    component: SecurityLink,
  },
}
